import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import AnagraficaPicker from "@/components/AnagraficaPicker";

// Sprint 3 — riapertura pratica annullata: se il cliente è stato azzerato lo chiede e lo invia.
export default function RiapriPraticaDialog({ open, onOpenChange, vendita, motivo, onDone }) {
  const [cliente, setCliente] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setCliente(vendita?.cliente_id || null); }, [open, vendita?.cliente_id]);
  const serveCliente = !vendita?.cliente_id;

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/vendite/${vendita.id}/transition_commerciale`, {
        stato_partenza: vendita.status,
        target_stato: "impegnata", motivo, ...(serveCliente ? { cliente_id: cliente } : {}),
      });
      toast.success(`Pratica ${vendita.codice || ""} riaperta (impegnata)`);
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Errore riapertura");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="riapri-pratica-dialog">
        <DialogHeader>
          <DialogTitle>Riapri pratica {vendita?.codice}</DialogTitle>
          <DialogDescription>
            La pratica tornerà allo stato "impegnata" e sarà di nuovo modificabile.
            {serveCliente && " L'annullamento ha rimosso il cliente: indicalo per riaprire."}
          </DialogDescription>
        </DialogHeader>
        {serveCliente && (
          <AnagraficaPicker label="Cliente" value={cliente} onChange={setCliente} required
            contextCompanyId={vendita?.company_id || null} testIdPrefix="riapri-cliente" />
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>Annulla</Button>
          <Button onClick={submit} disabled={busy || (serveCliente && !cliente)} data-testid="riapri-pratica-conferma">
            {busy ? "Riapertura..." : "Riapri pratica"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
